import type {
  ModalActivateAction,
  ModalDeactivateAction,
  ModalPopScreenAction,
  ModalPushScreenAction,
} from "domains/modal/actionTypes";
import { ModalTypes } from "domains/modal/actionTypes";
import type { ModalContentType } from "domains/modal/types";

export const activateModal = <T extends ModalContentType>(
  meta: ModalActivateAction<T>["meta"],
): ModalActivateAction<T> => ({
  type: ModalTypes.ACTIVATE,
  meta,
});

export const deactivateModal = (): ModalDeactivateAction => ({
  type: ModalTypes.DEACTIVATE,
});

export const pushModalScreen = <T extends ModalContentType>(
  meta: ModalPushScreenAction<T>["meta"],
): ModalPushScreenAction<T> => ({
  type: ModalTypes.PUSH_SCREEN,
  meta,
});

export const popModalScreen = (): ModalPopScreenAction => ({
  type: ModalTypes.POP_SCREEN,
});
